export const getTabsItems = (t: (key: string) => string) => [
  {
    key: 'routes',
    title: t('transportCompaniesDetailTabRoutes'),
  },
]
